var exports = {
  "W": "xf61da738--cfb945--labels",
};

module.exports = exports;
